import React, { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";

const IdpSkipContext = createContext(false);
export const useCameViaIdP = () => useContext(IdpSkipContext);

export const IdpSkipProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { state } = useLocation();
  return <IdpSkipContext.Provider value={!!state?.cameViaIdP}>{children}</IdpSkipContext.Provider>;
};
